import React from 'react'
import moment from "jalali-moment";
import './BlogItemSlider.css'
function BlogItemSlider(props) {
  return (
    <div>
        <div className='topItemBlogPage'>
            <div className='imgTopItemBlog'><img alt='' src={props.image}/></div>
            <div className='infTopItemBlog'>
                <h4 style={{textAlign: "right"}}>{props.title}</h4>
                <div className='tagItemBlog'><div>{props.tag}</div></div>
                <div className='infoTimesBlogItem' style={{justifyContent: "flex-start"}}>
                  <span style={{marginLeft: "8px"}}>نوشته شده در : </span>
                  {props.date !== "" ? (
                    <span>{moment(props.date).locale("fa").format("YYYY/MM/DD")}</span>
                  ) : (
                    <span></span>
                  )}
                </div>
            </div>
        </div>
    </div>
  )
}

export default BlogItemSlider